const shortDate = (date: string) => new Date(date).toLocaleDateString(navigator.language, {
    year: "numeric",
    month: "short",
    day: "numeric"
})

const longDate = (date: string) => {
    const d = new Date(date)
    const datePart = d.toLocaleDateString(navigator.language, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    })

    const timePart = d.toLocaleTimeString(navigator.language, {
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
        timeZoneName: 'short'
    })

    return `${datePart} at ${timePart}`
}

const lastUsed = (date: string) => {
    const now = new Date();
    const lastUsed = new Date(date);
    const diff = now.getTime() - lastUsed.getTime(); // get time difference in milliseconds
    const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor(diff / (1000 * 60));
    const seconds = Math.floor(diff / 1000);
    if (months > 0) {
        return `${months} month${months > 1 ? 's' : ''} ago`;
    } else if (days > 0) {
        return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (minutes > 0) {
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else if (seconds > 0) {
        return `${seconds} second${seconds > 1 ? 's' : ''} ago`;
    } else {
        return `just now`;
    }
}

const fromNow = (days: number) => {
    const now = new Date();
    const date = new Date(now.setDate(now.getDate() + days));
    return date.toLocaleDateString(navigator.language, {
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric"
    })
}

const fromTimestamp = (dateTimeString: string) => {
    const date = new Date(dateTimeString);
    const options: Intl.DateTimeFormatOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };

    return date.toLocaleString(navigator.language, options);
}

const remainingDays = (date: string) => {
    const now = new Date();
    const dueDate = new Date(date);
    const diff = dueDate.getTime() - now.getTime(); // get time difference in milliseconds
    return Math.floor(diff / (1000 * 60 * 60 * 24));
}


export const useDate = () => {
    return {
        shortDate,
        longDate,
        lastUsed,
        fromNow,
        fromTimestamp,
        remainingDays
    }
}
